import i18n from '@/i18n'
import { mcToast } from '@/plugins/McToastAlertPlugin'

export const state = {
  activePopups: [],
}

export const mutations = {
  ADD_POPUP(state, popup) {
    state.activePopups.push(popup)
    localStorage.setItem('ctPopups', JSON.stringify(state.activePopups))
  },

  REMOVE_POPUP(state, vehicleId) {
    const index = state.activePopups.findIndex((popup) => popup.id === vehicleId)
    if (index !== -1) {
      state.activePopups.splice(index, 1)
      localStorage.setItem('ctPopups', JSON.stringify(state.activePopups))
    }
  },

  LOAD_POPUPS(state, popups) {
    state.activePopups = popups
  },

  SET_POPUP_TO_LOCALSTORAGE(state) {
    localStorage.setItem('ctPopups', JSON.stringify(state.activePopups))
  },

  UPDATE_POPUP(state, { id, data }) {
    const popupIndex = state.activePopups.findIndex((p) => p.id === id)
    if (popupIndex !== -1) {
      state.activePopups[popupIndex].data = data
    }
  },
}

export const actions = {
  addPopup({ commit, state }, { ctData, callState }) {
    const isExists = state.activePopups.some((popup) => popup.id === ctData.vehicleId)
    if (isExists) return
    if (state.activePopups.length >= 9) {
      mcToast.warning(i18n.t('notification.text.limitNotification'), { timeout: 1000 })
      return
    }

    const newPopup = {
      id: ctData.vehicleId,
      data: ctData,
      callState,
      x: Math.floor(Math.random() * 300),
      y: Math.floor(Math.random() * 300),
    }
    commit('ADD_POPUP', newPopup)
  },

  closePopup({ commit }, vehicleId) {
    commit('REMOVE_POPUP', vehicleId)
  },

  setActivePopupsToLocalStorage({ commit }) {
    commit('SET_POPUP_TO_LOCALSTORAGE')
  },

  updatePopupData({ commit }, payload) {
    commit('UPDATE_POPUP', payload)
  },
}
